import Slider from '../../IgGallery/Elements/Slider';

/**
 * Testimonials
 */
const Testimonials = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		TESTIMONIALS: '.testimonials-wrap',
	};

	/**
	 * Testimonials
	 *
	 * @class
	 * @augments Slider
	 */
	class Testimonials extends Slider {
		onReady() {
			this.initialize({
				items: 1,
				animateIn: 'fadeIn',
				animateOut: 'fadeOut',
				mouseDrag: false,
				touchDrag: false,
				autoplay: true,
				autoplayHoverPause: true,
				loop: true,
				dots: true
			});
		}
	}

	return Testimonials._getElements(Selector.TESTIMONIALS, Testimonials);
})();

export default Testimonials;
